/* 
©2021 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/
import "oe-combo/oe-combo.js";

/** 
 * This element is used to display the dropdown component 
 * @customElement
 * @polymer
 * @demo node_modules/speedboat_ui/elements/demo/app-combo-demo.html
 * @summary Technical component
*/
const OeCombo = window.customElements.get('oe-combo');

class appCombo extends OeCombo {

  static get properties() {
    return {
      /*Flag to change the display for multiselect*/
      defaultDisplay: {
        type: Boolean,
        notify: true,
        value: false
      }
    }
  }

  /** 
   * Method to validate selected lists
   * @param {object} value
   * @param {array} listItems
   * @param {object} menuList
  **/
  _validateArrayItems(value, listItems, menuList) {
    var selectedItemsIndex = [];
    var selectedItems = [];
    var displayValues = [];

    for (var idx = 0, len = listItems.length; idx < len; idx++) {
      var item = listItems[idx];

      if (value.indexOf(this._getItemValue(item)) !== -1) {
        selectedItems.push(item);
        selectedItemsIndex.push(idx);
        displayValues.push(this._getDisplayValue(item));
      }
    }

    if (selectedItems.length > 0) {
      this.displayValue = this.defaultDisplay ? displayValues.length + " Selected" : this.displayValue = displayValues.join(', ');  //Customize this line to change the display
    }

    this.set('selectedItems', selectedItems);
    this.set('__prevSelectedValues', selectedItemsIndex.sort().join());

    if (selectedItems.length === value.length) {
      menuList && menuList.set('selectedValues', selectedItemsIndex);
      this.setValidity(true, undefined);
    } else {
      this.setValidity(false, 'invalidValue');
    }
  }

}

window.customElements.define('app-combo', appCombo);